// 专供客户端ajax请求使用
import axios from 'axios'
import app from '@/main'
import store from '@/store'
import errorTips from '@/assets/json/errorTips'

axios.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 204 // default
}
const ajax = type => async (
  url,
  data = {},
  { ignoreMsg = false, ignoreToken = false, loading = true } = {},
  ext = { timeout: 10000 }
) => {
  const config = {}
  if (!ignoreToken) {
    config.withCredentials = true
  }
  Object.assign(config, ext)
  config.url = /^https?/.test(url) ? url : CONFIG.api_edu + url
  config.method = type
  if (['put', 'post', 'patch'].includes(type)) {
    config.data = data
  }
  if (type === 'get') {
    config.params = Object.assign({}, data)
    config.params.TIME = +new Date()
  }

  try {
    loadingSwitch(loading)
    const res = await axios(config)
    loadingSwitch(false)
    return res.data
  } catch (error) {
    loadingSwitch(false)
    const response = error.response
    let errorCode
    let errorMessage
    if (response) {
      const data = response.data
      errorCode = data.error_code || data.status
      errorMessage =
        data.error_message ||
        data.message ||
        errorTips[errorCode] ||
        `未定义错误号 ${errorCode} 的错误提示`
      if (errorCode === 100010) {
        app.$message.error('登录态失效，请重新登录')
        store.dispatch('logout')
        return Promise.reject({ error_code: 100010 })
      }
      if (errorCode === 110001) {
        app.$message.error('非学生账号')
        setTimeout(() => {
          store.dispatch('logout')
        }, 1000)
        return Promise.reject({ error_code: 110001 })
      } else if (errorCode === 20100004) {
        store.dispatch('logout')
      }
      if (
        (errorCode === 930000 || errorCode === 940000) &&
        store.state.isWeixin
      ) {
        setTimeout(window.wxAuth, 3000)
      }
    } else {
      errorMessage = error.message
      errorCode = error.status || 0
    }
    if (!ignoreMsg) app.$message(errorMessage)
    return Promise.reject({ error_code: errorCode })
  }
}

function loadingSwitch (loading) {
  if (app) {
    if (loading) {
      app.$loading(loading)
    } else {
      app.$loading.close()
    }
  }
}

export const head = axios.head
export const get = ajax('get')
export const post = ajax('post')
export const put = ajax('put')
export const patch = ajax('patch')
export const del = ajax('delete')
